import {
  REPORTS_LIST_REQUESTED,
  REPORTS_LIST_SUCCESSED,
  REPORTS_LIST_FAILED,
} from '../../constants/actionTypes';
 
const initialState = {
  listData: {},
  isLoading: null,
  isSuccess: null,
  hasErrors: null,
};

export const incidentReportsStore = (state = initialState, action) => {
  switch (action.type) {
    case REPORTS_LIST_REQUESTED: {
      return {
        ...state,
        listData: null,
        hasErrors: null,
        isProcessing: true,
        isSuccess: null,
      };
    }
    case REPORTS_LIST_SUCCESSED: {
      return {
        listData: action.data,
        hasErrors: null,
        isProcessing: false,
        isSuccess: true,
      };
    }
    case REPORTS_LIST_FAILED: {
      return {
        listData: action.data,
        hasErrors: true,
        isProcessing: false,
        isSuccess: null,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export default incidentReportsStore;
